import {
    forwardRef,
    Component,
    Input,
    ElementRef,
    ViewChild,
    HostBinding,
    Output,
    EventEmitter,
    SimpleChanges,
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
    ValidatorFn,
    AbstractControl,
    ValidationErrors,
    Validators,
    NG_VALIDATORS,
    Validator,
} from '@angular/forms';
import moment from 'moment';
import { Moment, MomentInput } from 'moment';
import { coerceBooleanProperty } from '../../utils';
import { DateService } from './date.service';

/**
 * The custom date picker component used to change a date and time.
 */
@Component({
    selector: 'text-date-time-picker',
    templateUrl: './text-datepicker.component.html',
})
export class TextDatepickerComponent 
{
    /**
     *
     */
    constructor(private dateService: DateService) {        
    }
    
    @Input()
    placeholder: string = '';

    @Input()
    initialDate: string = null;

    @Input()
    inputFieldClass: string = "";

    @Input()
    maxDate: string = '';

    @Output()
    dateChanged = new EventEmitter<string>();

    /**
     * The date and time.
     */
    value: string = "";

    ngOnChanges(changes: SimpleChanges){
        if(changes['initialDate']){
            const newInitialDateString = changes['initialDate'].currentValue;
            const parsedInitialDate = this.dateService.parseSQLDateTime(newInitialDateString);

            if (this.value.length === 0 && parsedInitialDate.isValid){
                const date = parsedInitialDate.value;
                this.value = this.dateService.getDisplayableDate(date);
            }
        }
    }

    onValueChanged(newValue: string){
        const parsedDate = this.dateService.parseHumanEnteredDate(newValue);
        if(parsedDate.isValid){
            const date = parsedDate.value;
            const dateString = this.dateService.mapToSqlDateTime(date);
            this.dateChanged.emit(dateString);   
        }
    }

    isDateValid(dateString: string | null | undefined): boolean{
        const parsedDate = this.dateService.parseHumanEnteredDate(dateString);
        if (!parsedDate.isValid){
            return false;
        }

        if (this.parsedMaxDate.isValid){
            const higherThanMaxDate = parsedDate.value > this.parsedMaxDate.value;
            if (higherThanMaxDate){
                return false;
            } 
        }

        return true;
    }

    get displayableDate(){
        const parsedDate = this.dateService.parseHumanEnteredDate(this.value);
        
        if (!parsedDate.isValid){
            return this.value;
        }

        return parsedDate.value.toLocaleString('en-GB', {day: 'numeric', month : 'long', year: 'numeric'});
    }

    get parsedMaxDate(): {isValid: boolean, value?: Date}{
        return this.dateService.parseHumanEnteredDate(this.maxDate);
    }
}
